import React from 'react';
import classnames from 'classnames';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
// import moment from 'moment';
import dateLib from '@/utils/dateLib/moment';
import { MOMENT_LANG } from '@/utils/locale';
import './style.scss';
const PREFIX = 'date-time-container';

@observer
export default class DateTime extends React.PureComponent {
  @observable time = '';

  constructor(props) {
    super(props);
  }

  @action
  async updateState(key, value) {
    this[key] = value;
  }

  componentDidMount() {
    let nowTime = dateLib.format(this.props.time, 'MMM DD, hh:ii A');
    if (MOMENT_LANG === 'en') {
      nowTime = nowTime.toUpperCase();
    }
    this.updateState('time', nowTime);
  }

  render() {
    // 如果原 announcement 不存在则不展示首屏 datetime，如果原 announcement 存在要一直展示首屏daytime
    const isHidden = this.props.isFisrtTime && this.props.hiddenDatetime;
    return (
      <div
        className={classnames(PREFIX, 'date-time', {
          'first-datetime': this.props.isFisrtTime,
          'sapce-top-ios': this.props.isIOS,
          'sapce-top-android': !this.props.isIOS,
          'hidden-datetime': isHidden,
          'has-history': this.props.hasHitory,
          'has-history-prompt': this.props.hasGetHistoryPrompt,
        })}
      >
        {!isHidden && <p>{this.time}</p>}
      </div>
    );
  }
}
